if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}


(function () {
  function initMediaDots(root = document) {
    const galleries = Array.from(root.querySelectorAll("[id^='MediaGallery-']"));
    if (!galleries.length) return;

    galleries.forEach((gallery) => {
      // avoid double-init per gallery
      if (gallery.dataset._dotsInit) return;
      gallery.dataset._dotsInit = "true";

      // find matching pagination container
      const sectionSuffix =
        gallery.id.replace(/^MediaGallery-/, "") ||
        gallery.dataset.section ||
        gallery.dataset.product;

      const pagination =
        document.getElementById(`MediaGalleryPagination-${sectionSuffix}`) ||
        gallery.querySelector(".media-gallery-pagination");

      if (!pagination) return;

      // avoid rebuilding dots if already built
      if (pagination.dataset.dotsBuilt) return;
      pagination.dataset.dotsBuilt = "true";

      // find slider
      let slider =
        gallery.querySelector("ul.slider") ||
        gallery.querySelector("slider-component") ||
        gallery;

      // find slide items
      let slides = Array.from(slider.querySelectorAll("li[id^='Slide-']"));
      if (!slides.length) {
        slides = Array.from(slider.children).filter(
          (n) => n.offsetWidth > 0 || n.querySelector("img")
        );
      }
      if (!slides.length) return;

      // build dots
      pagination.innerHTML = "";
      const dotButtons = [];

      slides.forEach((slide, idx) => {
        const btn = document.createElement("button");
        btn.type = "button";
        btn.className =
          "media-gallery-dot" +
          (idx === 0 ? " active" : "") +
          (slide.classList.contains("hide-media") ? " hide-media" : "");
        btn.setAttribute("aria-label", `Go to image ${idx + 1}`);
        btn.setAttribute("data-dot-index", idx);

        btn.addEventListener("click", () => {
          if (btn.classList.contains("hide-media")) return; // skip hidden
          const offset = slide.offsetLeft;
          slider.scrollTo({ left: offset, behavior: "smooth" });
          dotButtons.forEach((d, i) =>
            d.classList.toggle("active", i === idx)
          );
        });

        pagination.appendChild(btn);
        dotButtons.push(btn);
      });

      // helper to update active state
      const setActive = (index) => {
        dotButtons.forEach((d, i) => d.classList.toggle("active", i === index));
      };

      // observe slide visibility
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              const idx = slides.indexOf(entry.target);
              if (idx !== -1) setActive(idx);
            }
          });
        },
        { root: slider, threshold: 0.6 }
      );

      slides.forEach((s) => {
        try {
          io.observe(s);
        } catch (e) {}
      });

      // keep observer ref for cleanup if needed
      gallery._dotsObserver = io;
    });
  }

  // run on DOM load
  document.addEventListener("DOMContentLoaded", () => initMediaDots(document));

  // re-run when Shopify sections are loaded/reloaded
  document.addEventListener("shopify:section:load", (e) =>
    initMediaDots(e.target || document)
  );
  document.addEventListener("shopify:section:reorder", (e) =>
    initMediaDots(e.target || document)
  );
  document.addEventListener("shopify:section:select", (e) =>
    initMediaDots(e.target || document)
  );
})();
